<template>


    <div>


        <div class="mx-auto my-8 p-8 w-4/6 bg-white shadow-lg" id="print_area">
            <div class="flex justify-between">
                <img src="https://www.ausa.com.mx/img/logo-ver2.png" alt="ausa_Logo" width="150" height="90"
                     style="aspect-ratio: 120 / 60; object-fit: contain; ">
                <div class="flex-grow"> </div>
                <div class="text-right">
                    <p style="color:Blue" class="text-sm">Datos de usuario</p>
                    <p style="color:Blue" class="text-xs">Sistema de gestion de calidad</p>
                    <p style="color:Blue" class="text-xs">ISO 9001:2008 NMX-CC-9001-IMNC-2008</p>
                </div>
            </div>
            <hr>
            <div class="mt-6 detalle-usuario">
                <p>Nombre: {{ this.detalleUsuario.NombreCompleto }}</p>
                <p>Departamento: {{ this.detalleUsuario.Area }}</p>
                <p>Puesto: {{ this.detalleUsuario.Puesto }}</p>
                <p>Usuario: {{ this.detalleUsuario.Uslogin }}</p>
                <p>Contraseña: {{ this.detalleUsuario.Password }}</p>
                <p>Fecha de nacimiento: {{ this.detalleUsuario.FechaNacimiento }}</p>
                <p>Extensión: {{ this.detalleUsuario.Extension }}</p>
                <p>Correo electrónico: {{ this.detalleUsuario.Correos }}</p>
                <p>Clave IVR: {{ this.detalleUsuario.Ivr }}</p>
                <p>Agente: {{ this.detalleUsuario.AgenteQuemetrix }}</p>
                <p>Clave Agente: {{ this.detalleUsuario.CveAgente }}</p>
                <p>Clave Telefonica: {{ this.detalleUsuario.Tarificador }}</p>
                <p>Fecha de alta: {{ this.detalleUsuario.FechaAlta }}</p>
                <p>El usuario fue dado de alta por: {{ this.detalleUsuario.UsuarioAlta }}</p>
            </div>
            <div class="mt-8 text-sm">
                <p>Nota importante:</p>
                <ul style="font-style: italic" class="list-disc pl-5">
                    <p style="font-style: italic">
                        - No utilizar estas claves para uso personal como son cajeros, cuentas
                        de
                        Internet. Etc.
                    </p>
                    <p style="font-style: italic">
                        Te recordamos que estas claves son personales y no deberán de ser
                        proporcionadas a nadie
                    </p>
                </ul>
            </div>
            <div class="mt-6 flex justify-between">
                <button class="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:bg-primary/90 h-10 px-4 py-2 bg-blue-600 text-white"
                        @click="() => this.$router.push({ name: 'DetalleUsuario' })">
                    REGRESAR
                </button><button class="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:bg-primary/90 h-10 px-4 py-2 bg-green-500 text-white"
                                 @click="Imprimir">
                    IMPRIMIR
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapState } from "vuex";
    import SistemasService from '@/services/Sistemas/sistemas.service'
    import MetodosGenerales from "@/utils/metodosgenerales.vue.js";

    export default {
        async mounted() {
            await this.ObtenerDetalleUsuario();

        },
        data: () => {
            return {
                detalleUsuario: {},
            }

        },
        async mounted() {
            await this.ObtenerDetalleUsuario();

        },
        computed: {
            ...mapState({ drawer: (state) => state.drawer }),
            ...mapState(["domain", "informationPage"]),
            DRAWER_STATE: {
                get() {
                    return this.drawer;
                },
            },
        },
        methods: {
            ...mapActions(["TOGGLE_DRAWER"]),
            toggleDrawerAction() {
                this.TOGGLE_DRAWER(); // Llamada a la acción TOGGLE_DRAWER
            },

            async ObtenerDetalleUsuario() {
                let datosUser = await MetodosGenerales.obtenerSessionReporte('DetalleUsuarioBusqueda')
                await SistemasService.ObtenerDetalleUsuario(datosUser.Login).then((res) => {
                    this.detalleUsuario = res
                    this.detalleUsuario.colorInactividad = this.detalleUsuario.Inactividad ? '#ddad46' : '#318c58'
                })
            },
            Imprimir() {
                if (this.DRAWER_STATE) this.toggleDrawerAction()

                this.delay(300).then(() => {
                    window.print()
                })

            },

            delay(time) {
                return new Promise(resolve => setTimeout(resolve, time));
            }
        }

    }
</script>

<style>
    .detalle-usuario p {
        color: gray;
    }

    @media print {

        .v-footer,
        button,
        .v-navigation-drawer,
        .helper,
        header,
        .main-header {
            display: none !important
        }

        #print_area {
            width: 100%;
            /* Hacer que el elemento ocupe todo el ancho de la página */
            height: 100%;
            /* Hacer que el elemento ocupe todo el alto de la página */
            overflow: auto;
            box-shadow: none;
        }

        .v-main {
            width: 100%
        }

        #advertencia_pruebas {
            display: block !important;
        }
    }

    .v-navigation-drawer {
        /* display:none; */
    }
</style>